export default __webpack_public_path__ + "static/media/grafema_ummi_07.530c670a.jpg";